import styled, { css } from 'styled-components';

const getResultsListTopShadow = props => {
  return css`
    &:after {
      content: '';
      position: relative;
      width: 100%;
      height: ${props => props.theme.spacing.large};
      background-color: transparent;
      box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.2);
      display: block;
      z-index: 2;
      margin-bottom: ${props => props.theme.spacing.xxsmall};
    }
  `;
};

const StyledTaxonomyExplorer = styled.div`
  padding-top: ${props => props.theme.spacing.medium};
  padding-bottom: ${props => props.theme.spacing.medium};
  padding-left: ${props => props.theme.spacing.large};
  padding-right: ${props => props.theme.spacing.large};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledTaxonomyResultsContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const StyledResultContainerWrapper = styled.div`
  position: relative;
  flex: 1 1 0%;
  overflow: hidden;
`;

const StyledTaxonomyFilters = styled.div`
  position: relative;
  ${props => getResultsListTopShadow(props)};
`;

const StyledResultsEmptyStateContainer = styled.div`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const StyledFilters = styled.div`
  display: flex;
  padding-top: ${props => props.theme.spacing.medium};
`;
export {
  StyledTaxonomyExplorer,
  StyledResultContainerWrapper,
  StyledResultsEmptyStateContainer,
  StyledTaxonomyResultsContainer,
  StyledTaxonomyFilters,
  StyledFilters,
};
